export default __webpack_public_path__ + "static/media/789711126073049108.a5b09beb.png";